import React from 'react'

function CV () {
  return (
    <div className='profile__cv'>
      <a href='./Robyn%20Veitch%20CV%20-%20Website.pdf'>Click here to view my CV</a>
    </div>
  )
}

export default CV
